
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw, useTranslate } from '../../lib'
// import AsideBar from './AsideBar'

import './compliance-improvents.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function ComplianceImprovents(props) {
    const { data } = props
    const [loading, setLoading] = useState(false)
    const [assement, setAssement] = useState(data)
    const { t } = useTranslate();

    useEffect(() => {
        setAssement(data)
    }, [data])

    const getClass =   (acurracy) => {
        if (acurracy < 50) {
            return 'red'
        }
        else {
            return 'orange'
        }
    }

    const getImproventsCompliance = () => {
        const improvent = assement?.assesment?.compliance?.improvements || [];
        return improvent.map((item) => ({
            ...item,
            'class': getClass(item.accuracy)
        }));

    }

    const getResolutionImprovents = () => {
        return assement.assesment.resolution.improvements.map((item) => ({
            ...item,
            'class': getClass(item.accuracy)
        }));
    }

    const getDisclaimerImprovents = () => {
        return assement.assesment.disclaimer.improvements.map((item) => ({
            ...item,
            'class': getClass(item.accuracy * 100)
        }));
    }
    return (

        <>
            <div class="compliance">
                {assement.type === 'NLP' && <h3 className='font-bold text-[#36A9E1]'  >{t('reports.compliance')}</h3>}
                {getImproventsCompliance().map((item, index) => (
                    <div key={index} class="conversation conversation-suggested"  >
                        <div class="text-agent">
                            <div class="text">
                                <span className={item.class} >
                                    {item.used_phrase === '' ? item.intent : item.used_phrase}
                                </span>
                                <img src={`/icons/triangle${item.class}.png`} alt="" />
                                <b>{t('reports.weRecomend')}</b>
                            </div>
                        </div>

                        <div class="text-client">
                            {item.suggested_phrase}
                        </div>
                    </div>
                ))}

                {assement.type === 'NLP' && <h3 className='font-bold text-[#36A9E1]'  > {t('reports.resolution')}</h3>}

                {getResolutionImprovents().map((item, index) => (

                    <div key={index} class="conversation conversation-suggested"  >
                        <div class="text-agent">
                            <div class="text">
                                <span className={item.class}>
                                    {item.used_phrase === '' ? item.intent : item.used_phrase}
                                </span>
                                {assement.type === 'NLP' && <img src={`/icons/triangle${item.class}.png`} alt="" />}
                                {assement.type === 'NLP' && <b>{t('reports.weRecomend')}</b>}
                            </div>
                        </div>
                        
                        {assement.type !== 'NLP' && 
                        <div class="text-client">
                            <span>
                            <b>{((item?.isNumeric || 0) == 0) ? t('common.no') : ((item?.accuracy || 0)/10).toFixed(1).toString() +'/10'}</b> {' ' + (item?.reason || '')}
                            </span>
                        </div>}

                        <div class="text-client">
                            <span>
                                {assement.type !== 'NLP' && <b>{t('reports.suggestion')}:</b>} {item.suggested_phrase}
                            </span>
                        </div>
                    </div>))
                }

                {assement.type === 'NLP' && <h3  className='font-bold text-[#36A9E1]'  > {t('reports.disclaimer')}</h3>}

                {getDisclaimerImprovents().map((item, index) => (
                    <div class="conversation conversation-suggested"   >
                        <div class="text-agent"> 
                            <div class="text">
                                <span className={item.class}>
                                    {item.used_phrase === '' ? item.intent : item.used_phrase}
                                </span>
                                <img src={`/icons/triangle${item.class}.png`} alt="" />
                                <b>{t('reports.weRecomend')}</b>
                            </div>
                        </div>
                        <div class="text-client">
                            {item.suggested_phrase}
                        </div>
                    </div>))}
            </div>


        </>


    )
}
